export default class CustomEvents {
    constructor(comm) {
        this.comm = comm;
        /* polyfill for CustomEvent  https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent#Polyfill */
        (function () {

            if ( typeof window.CustomEvent === "function" ) return false;

            function CustomEvent ( event, params ) {
                params = params || { bubbles: false, cancelable: false, detail: null };
                var evt = document.createEvent( 'CustomEvent' );
                evt.initCustomEvent( event, params.bubbles, params.cancelable, params.detail );
                return evt;
            }

            window.CustomEvent = CustomEvent;
        })();
        /* end polyfill for CustomEvents */
    }

    dispatchEvent(payload) {
        // if (payload.type === "auth_response") {
        //     this.dispatchRegisterInstance();
        //     return;
        // }

        if (payload.type === "batch") {
            payload.data.forEach((d) => {
                try {
                    let acc = d.action || d.type;

                    if (d.data && (d.module === '"integration_player_notifications"' || d.instance === 'integration_player_notifications') && d.data.walletProviderCode === 'POKERSTARS') {
                        window.postMessage({'integration_player_notifications': d.module, 'walletProviderCode': d.data.walletProviderCode, ...d.data.messageContent}, '*')

                        return;
                    }

                    if (d.data && (d.module === '"integration_player_notifications"' || d.instance === 'integration_player_notifications') && d.data.walletProviderCode === 'PLAYTECH') {
                        window.postMessage({'integration_player_notifications': d.module, 'walletProviderCode': d.data.walletProviderCode, ...d.data.messageContent}, '*')

                        return;
                    }

                    if (d.type === 'playerAction_response') {
                        acc =  d.action.toLowerCase();
                    }
                    if (d.error) {
                        this.comm.registeredInstances[`${d.module}_${d.instance}`].status = "ERROR";
                    } else if (d.data && d.data.status) {
                        this.comm.registeredInstances[`${d.module}_${d.instance}`].status = d.data.status;
                    }

                    if (acc === "instanceAvailable") {
                        this.comm.api.modules.initiateInstance(d);
                        return;
                    }

                    window.dispatchEvent(new CustomEvent(`oryx_${d.module.toLowerCase()}_${d.instance}_${acc.toLowerCase()}`, {"detail": d}));
                } catch (e) {
                    // console.error(e);
                    // normal flow ... some push msg dont have module, instance, ... they do not need to be dispatched
                }
            });
        } else {
            if (payload.type === "instanceAvailable") {

                this.comm.api.modules.initiateInstance(payload);
                return;
            }

            if (payload.type === null && payload.error) {
                if (payload.error.message) {
                    logger.debug("No api decoder", payload.error.message);
                }

                return;
            }

            if (payload.type === "player_properties") {
                window.dispatchEvent(new CustomEvent(`oryx_${payload.type}`, {"detail": payload}));

                return;
            }

            window.dispatchEvent(new CustomEvent(`oryx_${payload.module.toLowerCase()}_${payload.instance}_${payload.type === 'playerAction_response' ? payload.action.toLowerCase() : payload.type.toLowerCase()}`, {"detail": payload}));
        }
    }

    // dispatchRegisterInstance() {
    //     window.dispatchEvent(new CustomEvent(`oryx_register_instance`));
    // }

}
